<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-button tag="a" :href="urlOfRecord" type="is-dark" target="_blank" v-if="record">Bekijk verhuurpagina</b-button>
            </div>
            <div class="column small-9">
                <h1>Online verhuur instellingen</h1>
            </div>
        </div>

        <div v-if="user.role == 'pit' && dataBelongsTo == 'all'" class="row">
            <div class="column">
                <form class="form" style="overflow: auto;">
                    <div class="column text-center">
                        <br>
                        <h4>Kies eerst een organisatie!</h4>
                    </div>
                </form>
            </div>
        </div>

        <div class="row" v-else-if="_.isNull(record) && !loading">
            <div class="column">
                <form class="form" style="overflow: auto;">
                    <div class="column text-center">
                        <br>
                        <h4><span v-if="user.role == 'pit'">Deze</span><span v-else>Je</span>&nbsp;organisatie heeft nog geen online verhuur instellingen.</h4>
                        <p>Het is mogelijk om de online verhuur (tijdelijk) uit te zetten of te verwijderen. Wil je de instellingen aanmaken?</p>

                        <b-button type="is-success" @click="create">Instellingen aanmaken</b-button>
                    </div>
                </form>
            </div>
        </div>

        <div v-else-if="_.has(record, 'id') && !loading" class="row">
            <div class="column">
                <form class="form" style="overflow: auto;">

                    <div class="column">
                        <h3>Status en tijdelijke inactiviteit</h3>
                        <p class="margin0">Hier kun je de status van de online verhuur instellingen aanpassen. Ook kun je de online verhuur tijdelijk uitzetten door een inactieve periode in te stellen.</p>
                    </div>
                    <div class="column medium-4 small-12">
                        <b-field label="Status"
                            :message="getError(errors, 'status')"
                            :type="getType(errors, 'status', '')"
                        >
                            <b-select placeholder="Status" expanded v-model="record.status" :disabled="saving || loading">
                                <option value="active">Actief</option>
                                <option value="inactive">Inactief</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column medium-8 small-12 paddingtop0">
                        <div class="row" v-show="record.status == 'active'">
                            <div class="column medium-6 small-12">
                                <label class="label">Inactief vanaf</label>
                                <b-field
                                    :message="getError(errors, 'inactive_from')"
                                    :type="getType(errors, 'inactive_from', '')"
                                >
                                    <b-datepicker
                                        placeholder="Inactief vanaf"
                                        v-model="record.inactive_from"
                                        :disabled="saving || loading"
                                        expanded
                                        :min-date="new Date(new Date().setHours(0, 0, 0, 0))"
                                        :date-formatter="formatDate"
                                    ></b-datepicker>
                                    <b-button icon-left="times" type="is-danger" @click="record.inactive_from = null" v-show="!_.isNull(record.inactive_from)"></b-button>
                                </b-field>
                            </div>
                            <div class="column medium-6 small-12">
                                <label class="label">Inactief tot</label>
                                <b-field
                                    :message="getError(errors, 'inactive_to')"
                                    :type="getType(errors, 'inactive_to', '')"
                                >
                                    <b-datepicker
                                        placeholder="Inactief tot"
                                        v-model="record.inactive_to"
                                        :disabled="saving || loading"
                                        expanded
                                        :min-date="new Date(new Date().setHours(0, 0, 0, 0))"
                                        :date-formatter="formatDate"
                                    ></b-datepicker>
                                    <b-button icon-left="times" type="is-danger" @click="record.inactive_to = null" v-show="!_.isNull(record.inactive_to)"></b-button>
                                </b-field>
                            </div>
                        </div>
                    </div>

                    <div class="column">
                        <h3>Instellingen</h3>
                    </div>

                    <div class="column medium-4 small-12">
                        <b-field label="Titel"
                            :message="getError(errors, 'title')"
                            :type="getType(errors, 'title', '')"
                        >
                            <b-input placeholder="Voornaam" v-model="record.title" :disabled="saving || loading"></b-input>
                        </b-field>
                    </div>
                    <div class="column medium-8 small-12">
                        <label class="label">URL</label>
                        <b-field
                            :message="getError(errors, 'url')"
                            :type="getType(errors, 'url', '')"
                        >
                            <p class="control">
                                <span class="button is-static">{{ baseurl }}/online-huren/</span>
                            </p>
                            <b-input placeholder="URL" v-model="record.url" expanded :disabled="saving || loading"></b-input>
                            <a :href="urlOfRecord" target="_blank" v-show="record.website_back">
                                <b-button icon-left="eye" type="is-dark"></b-button>
                            </a>
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Knop 'Terug naar website' link"
                            :message="getError(errors, 'website_back') ? getError(errors, 'website_back') : 'Deze link stelt bezoekers in staat om terug te keren naar jouw website. Laat leeg om geen terug-knop te tonen.'"
                            :type="getType(errors, 'website_back', '')"
                        >
                            <b-input placeholder="Link in knop 'terug naar website'" v-model="record.website_back" :disabled="saving || loading"></b-input>
                        </b-field>

                        <b-checkbox v-model="record.hide_address" :true-value="1" :false-value="0" :disabled="saving || loading">
                            Verberg adres
                        </b-checkbox>
                    </div>

                    <div class="column">
                        <b-notification type="is-warning" v-if="hiddenBoxes > 0">
                            <p>{{ hiddenBoxes === 1 ? 'Er is momenteel 1 box' : `Er zijn momenteel ${hiddenBoxes} boxen` }} verborgen voor online verhuur. Deze {{ hiddenBoxes === 1 ? 'wordt' : 'worden' }} niet getoond op online verhuur pagina.</p>
                            <router-link class="button is-primary" :to="{ name: 'BoxesOverview', query: { 'list': 1, 'hide_online': 1 } }">Toon verborgen boxen</router-link>
                        </b-notification>

                        <h4>Welke boxen wil je aanbieden als (binnenkort) beschikbaar?</h4>

                        <div v-for="filter in possibleFilters" :key="filter.name" class="filter">
                            <b-checkbox v-model="selectedFilters" :native-value="filter.name" :class="filter.name" :disabled="saving || loading">{{ filter.label }}</b-checkbox>
                        </div>

                        <br>

                        <b-checkbox v-model="record.inactive" :true-value="1" :false-value="0" :disabled="saving || loading">
                            Toon alle boxes met andere statussen als 'niet beschikbaar'
                        </b-checkbox>
                    </div>

                    <div class="column">
                        <h4>Weergave</h4>
                        <p>Wanneer de lijstweergave en plattegrond beide uit staan, wordt enkel het interesse formulier getoond.</p>

                        <b-field>
                            <b-checkbox v-model="record.list" :true-value="1" :false-value="0" :disabled="saving || loading">
                                Toon lijstweergave
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="record.floorplan" :true-value="1" :false-value="0" :disabled="saving || loading">
                                Toon plattegrond
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="record.prices" :true-value="1" :false-value="0" :disabled="saving || loading">
                                Toon prijzen
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="record.sizes" :true-value="1" :false-value="0" :disabled="saving || loading">
                                Toon maatvoering
                            </b-checkbox>
                        </b-field>
                    </div>

                    <div class="column">
                        <h4>Bevestiging</h4>

                        <b-field label="E-mailadres voor reservering"
                            :message="getError(errors, 'email')"
                            :type="getType(errors, 'email', '')"
                        >
                            <b-input placeholder="Voornaam" v-model="record.email" :disabled="saving || loading"></b-input>
                        </b-field>

                        <b-field label="Type afronding"
                            :message="getError(errors, 'finalize')"
                            :type="getType(errors, 'finalize', '')"
                        >
                            <b-select expanded v-model="record.finalize" :disabled="saving || loading">
                                <option value="reserve">Reservering</option>
                                <option value="first-ideal" disabled>Eerste factuur betalen via iDeal (nog niet beschikbaar)</option>
                            </b-select>
                        </b-field>
                    </div>
                </form>

                <!-- Footer buttons -->
                <div class="row">
                    <div class="column">
                        <div class="formfooter">
                            <div class="column text-right">
                                <b-button type="is-success" :loading="saving || loading" :disabled="saving || loading" @click="save">Opslaan</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import toastMixin from '@/mixins/toastMixins'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import escalationMixin from '@/mixins/escalationMixin.js'
import statusFiltersMixin from '@/mixins/statusFiltersMixin.js'

export default {
    name: 'OnlineRentalSettings',

    mixins: [
        toastMixin,
        formvalidationMixin,
        escalationMixin,
        statusFiltersMixin
    ],

    data() {
        return {
            loading: false,
            saving: false,
            record: null,
            baseurl: window.location.origin,
            errors: {},
            hiddenBoxes: null
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        dataBelongsTo() {
            return this.$store.state.dataBelongsTo
        },

        urlOfRecord() {
            if (this.record) {
                return this.baseurl + '/online-huren/' + this.record.url
            }

            return false
        }
    },

    created() {
        if (this.dataBelongsTo !== 'all'){
            this.startup()
        } else if (this.user.role !== 'pit') {
            this.startup()
        }
    },

    methods: {
        startup() {
            this.loading = true

            axios.get('/api/online-rental', {
                params: { organisation: this.user.role === 'pit' ? this.dataBelongsTo : this.user.organisation_id },
                headers: { 'Authorization': 'bearer ' + this.$store.state.authToken }
            }).then((response) => {
                this.setRecord(response.data.record)
                this.hiddenBoxes = response.data.hiddenBoxes
            }).catch((error) => {
                if (error.response.data.error == 'not_found') {
                    this.record = null
                    return
                }

                console.error('[❌] Error while online rental record:', error)
                this.showError('Er is iets fout gegaan tijdens het ophalen van de online verhuur instellingen.')
            }).then(() => {
                this.loading = false
            })
        },

        formatDate(date) {
            if (date) {
                const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
                return new Date(date).toLocaleDateString('nl-NL', options)
            }

            return null
        },

        create() {
            this.loading = true

            axios.post('/api/online-rental/create', { organisation: this.user.role == 'pit' ? this.dataBelongsTo : this.user.organisation_id}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.setRecord(response.data)
            }).catch((error) => {
                console.error('[❌] Error while creating online rental record:', error)

                if (error.response.data?.error === 'unauthorized') {
                    this.showError('Je hebt geen rechten om de online verhuur instellingen aan te maken.')
                } else {
                    this.showError('Er is iets fout gegaan tijdens het aanmaken van de online verhuur instellingen.')
                }
            }).then(() => {
                this.loading = false
            })
        },

        save() {
            this.saving = true

            let payload = this.record
            payload.statusses = this.selectedFilters

            axios.put('/api/online-rental/' + this.record.id, payload, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.setRecord(response.data)
                this.showMessage('De online verhuur instellingen zijn opgeslagen.')
            }).catch((error) => {
                console.error('[❌] Error while saving online rental record:', error)

                if (error.response.data?.error === 'unauthorized') {
                    this.showError('Je hebt geen rechten om de online verhuur instellingen op te slaan.')
                } else {
                    this.showError('Er is iets fout gegaan tijdens het opslaan van de online verhuur instellingen.')
                }
            }).then(() => {
                this.saving = false
            })
        },

        setRecord(data) {
            if (data.inactive_from) {
                data.inactive_from = new Date(data.inactive_from)
            }
            if (data.inactive_to) {
                data.inactive_to = new Date(data.inactive_to)
            }

            this.$set(this, 'record', data)
            this.$set(this, 'selectedFilters', data.statusses ? JSON.parse(data.statusses) : [])
        }
    },

    watch: {
        dataBelongsTo() {
            this.startup()
        }
    }
}
</script>